/*
NAME: UsersList
DESC: Componente responsavel por listar o array de objetos contendo usuarios
props: 
- usuarioLogado: Tipo de usuario logado
- items: Array de objetos contendo usuarios
-refresh: Função que vem de um componente pai para atualizar a lista de usuarios através de um get
- RowsPerPage: Quantidade de linhas por pagina na tabela
- loading: Booleano para mostrar ou não o icone de carregando

NOTES:

*/

import { useEffect, useState } from "react";
import DateFormat from "../../usecases/DateFormat";
import ProjectTable from "../basic/ProjectTable";
import { Info, MarkEmailRead, Person } from '@mui/icons-material';
import { Button, CircularProgress, IconButton } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Pages from "../../pages/Pages";
import { useHistory } from "react-router";
import UserTypes from "../../models/UserTypes"
import UserUnlockOrLock from "../../usecases/UserUnlockOrLock";
import strings from '../../values/strings/strings'

const UserStatus = ({ item, i, items, onSetItems }) => {
    const [loadingStatusChange, setLoadingStatusChange] = useState(false)

    function onChangeStatus(item, i){
        setLoadingStatusChange(true);
        UserUnlockOrLock(item.id).then(() => {
           let newItem = {...item}
           let newItems = [...items]
           newItem.autorizado === 1 ? newItem.autorizado = 0 : newItem.autorizado = 1
           const itemIndex = items.findIndex(user => user.id === item.id)
           newItems[itemIndex] = newItem
           onSetItems(newItems) 
        }).catch(() => {
            console.error('Erro ao desbloquear ou bloquear usuário')
        })
        .finally(() => {
            setLoadingStatusChange(false)
        })
    }

    if (loadingStatusChange) {
        return <CircularProgress size={20} />
    }

    if (item.autorizado === 1) {
        return <IconButton color="success" onClick={()=>onChangeStatus(item, i)} ><LockOpenIcon/></IconButton>
    } else {
        return <IconButton color="error" onClick={()=>onChangeStatus(item, i)}><LockIcon/></IconButton>
    }

}

function UsersList({usuarioLogado, items, refresh, rowsPerPage, loading, style}) {
    const [headers, setheaders] = useState([
        '','',`${strings.getString('info_authorized')}`,"Usuário",`${strings.getString('info_name')}`,`${strings.getString('info_data')}`,`${strings.getString('info_equips')}`,
        `${strings.getString('info_tipo')}`,`${strings.getString('info_email')}`,`${strings.getString('info_telephone')}`,
    ]);
    const [itemnsTable, setitemnsTable] = useState([])
    const [usuarioLogado1, setUsuarioLogado] = useState(null)
    const [localItems, setLocalItems] = useState([])

    useEffect(() => {        
        if(usuarioLogado && usuarioLogado.tipo !== UserTypes.CLI && headers[2] !== "Usuário"){
            let headersNew = [...headers]
            setheaders(headersNew)        
        }else {
            let headersNew = [...headers]
            headersNew = [...headers.slice(0,2),`${strings.getString(' default_user_name')}`,...headers.slice(2,headers.length)]
            setheaders(headersNew)        
        }       
        setUsuarioLogado(usuarioLogado)        
    }, [usuarioLogado])

    useEffect(() => {
        if(items){
            setLocalItems(items)
            let userTabela = bindData(items)
            setitemnsTable(userTabela)
    }
    } , [items])

    const onSetItems = (newItems) => {
        setLocalItems(newItems)
        let userTabela = bindData(newItems)
        setitemnsTable(userTabela)
    }

    const history = useHistory();

    const bindData = (data)=>{
        let binded=[];
        
        binded = data.map((item, i)=>{
            let obj = {} 
            
                obj.info =  (<IconButton color="info" onClick={()=>redirectUser(item)}><Info/></IconButton>)
                obj.status= usuarioautorizado(item)
                obj.statusemail=autorizaemail(item)
                obj.lock = mudaStatusAutorizacao(item, i, data)
                if(usuarioLogado && usuarioLogado.tipo !== UserTypes.CLI) 
                    obj.usuario =<Button  onClick={()=>redirectUser(item)}> {item.nome} </Button>
                obj.data =DateFormat(new Date(item.data))
                obj.equips = item.quantidade_equips
                obj.tipo = item.tipo
                obj.email = item.email
                obj.telefone = item.telefone

                return obj
        })
        return binded;  
    }

    function mudaStatusAutorizacao(item, i, dataItems){
        return (
            <UserStatus key={item.id} item={item} i={i} items={dataItems} onSetItems={onSetItems} />
        )
        // if(item.autorizado === 1){
        //     return (<IconButton color="success" onClick={()=>statusItem(item, i)} ><LockOpenIcon/></IconButton>)
        // }else{
        //     return (<IconButton color="error" onClick={()=>statusItem(item, i)}><LockIcon/></IconButton>)
        // }        
    }

    // function statusItem(item, i){
    //     setLoadingStatusChange(true);
    //     UserUnlock(item).then(() => {
    //        let newItem = {...item}
    //        newItem.autorizado === 1 ? newItem.autorizado = 0 : newItem.autorizado = 1
    //        items[i] = newItem
    //        let binded = bindData(items)
    //        setitemnsTable(binded) 
    //     }).finally(() => {
    //         setLoadingStatusChange(false)
    //     })
    // }

    function usuarioautorizado(item){
        if(item.autorizado === 1) {
            return (<IconButton color="success" ><Person /></IconButton>)
        } else {
            return (<IconButton color="error" ><Person /></IconButton>)
        }
    }

    function autorizaemail(item){
        if(item.emailconfirmado === 1){
            return (<IconButton color="success" ><MarkEmailRead/></IconButton>)
        }else{
            return (<IconButton color="error" ><EmailIcon/></IconButton>)
        }
    }
   
    function redirectUser(item){
        history.push(Pages.routes.Users + "/" + item.id)
    }

    function detalhesUsuarios(){
        history.push(Pages.routes.Users)
    }

    

   return (
    <ProjectTable 
    rowsPerPage={rowsPerPage} 
    style={{flex:1, width:'100%', maxWidth:'100%'}} 

    loading={loading}   
    headers={headers} 
    items={itemnsTable} 
    onRefresh={refresh} 
    title={strings.getString('screen_list_user')}
    onViewMore={detalhesUsuarios}
   />

   );
}

export default UsersList;